import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Answer = lazy(() => import('./Answer'))
const Browse = lazy(() => import('./Browse'))

const routes: RouteObject[] = [
    {
        path: '/clinical-questionnaires',
        element: <Browse />
    },
    {
        path: '/clinical-questionnaires/update/:consultationId',
        element: <Answer />
    },
    {
        path: '/clinical-questionnaires/view/:consultationId',
        element: <Answer />
    }
]

export default routes
